module.exports = __webpack_public_path__ + "img/feature_collaboration.84d8a77.png";